module.exports = __webpack_public_path__ + "img/icon-Exchange.55861da0.png";